export default __webpack_public_path__ + "static/media/SphereCoreMatter.138e65ae.webp";